import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../auth-context.js'
import LoadingState from './LoadingState.jsx'

function isAdminUser(user) {
  return user?.isAdmin === true || user?.is_admin === true
}

function RequireAuth({ children, admin = false }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) return <LoadingState label="正在验证登录状态" />
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />
  }
  if (admin && !isAdminUser(user)) return <Navigate to="/" replace />
  return children
}

export default RequireAuth
